import React from 'react';

export default () => (
  <div>
    <p>Loading</p>
  </div>
);
